const getCardResponse = (rawData: any) => {
  const result = rawData?.data?.data || []
  return result.map((keyMetric: any) => {
    const { label, value, info } = keyMetric || {}
    return {
      value,
      info,
      label,
    }
  })
}

const keyMetricsFormattedResponses = {
  getCardResponse,
}

export default keyMetricsFormattedResponses
